import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './Home.css';

const products = [
  {
    to: '/sexlife-tracker',
    name: 'My SexLife Tracker',
    tagline: 'Sex tracker & games for couple',
    description:
      'A private relationship wellness journal to help couples better understand their connection, preferences, and shared experiences.',
    android: 'https://play.google.com/store/apps/details?id=com.datos.sexlifetracker',
    ios: 'https://apps.apple.com/us/app/my-sexlife-tracker/id6753984259',
    category: 'Health & Fitness',
    image: '/images/sex-life-tracker/my-sexlife-tracker-app-preview.png',
    imageAlt: 'My SexLife Tracker app preview – couple relationship wellness journal',
  },
  {
    to: '/growiq',
    name: 'GrowIQ',
    tagline: 'Grow Your Knowledge with Interactive Quizzes',
    description:
      'Discover hundreds of quizzes across technology, history, science, arts, and more. Track your progress as you engage in active learning.',
    web: 'https://growiq.app/',
    category: 'Education',
    image: '/images/growiq/growiq-interactive-quiz-app-preview.png',
    imageAlt: 'GrowIQ interactive quiz app preview – grow your knowledge with quizzes',
  },
  {
    to: '/feel-o-meter-ai-mood-tracker',
    name: 'Feel-O-Meter',
    tagline: 'AI-Powered Mood Tracking',
    description:
      'Master your emotions. Build resilience. Live fully. Track feelings, uncover patterns, and nurture mental health with AI-powered insights.',
    android: 'https://play.google.com/store/apps/details?id=com.appshow.feelometer',
    ios: 'https://apps.apple.com/us/app/feel-o-meter-ai-mood-tracker/id6752644814',
    category: 'Lifestyle',
    image: '/images/feel-o-meter/feel-o-meter-ai-mood-tracker-app-preview.png',
    imageAlt: 'Feel-O-Meter AI mood tracker app preview – emotional wellness journal',
  },
  {
    to: '/rewardly-ai-card-rewards',
    name: 'Rewardly AI',
    tagline: 'Maximize Your Card Rewards',
    description:
      'Your complete credit card rewards companion. Turn everyday spending into incredible rewards, plan trips with points, and get AI-powered card recommendations.',
    android: 'https://play.google.com/store/apps/details?id=com.appshow.rewards',
    ios: 'https://apps.apple.com/in/app/rewardly-ai-card-rewards/id6756515642',
    web: 'https://rewardlyai.com/',
    category: 'Finance',
    image: '/images/rewardly-ai/rewardly-ai-card-rewards-app-preview.png',
    imageAlt: 'Rewardly AI card rewards app preview – maximize credit card rewards',
  },
  {
    to: '/price-tracker-deal-alerts',
    name: 'Price Tracker: Deal Alerts',
    tagline: 'Price Drop Alerts & History',
    description:
      'Track prices and get deal alerts when they drop. Add a product link, set a target price, and shop at the right time with price history insights.',
    android: 'https://play.google.com/store/apps/details?id=com.appshow.pricedrop',
    ios: 'https://apps.apple.com/us/app/price-tracker-deal-alerts/id6758753391',
    category: 'Shopping',
    image: '/images/price-tracker/price-tracker-deal-alerts-app-preview.png',
    imageAlt: 'Price Tracker Deal Alerts app preview – track prices and get deal notifications',
  },
];

const AndroidIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.523 15.341a.914.914 0 01-.913.912.912.912 0 01-.912-.912.913.913 0 01.912-.913.914.914 0 01.913.913zm-9.219 0a.914.914 0 01-.913.912.912.912 0 01-.912-.912.913.913 0 01.912-.913.914.914 0 01.913.913zM17.9 10l1.448-2.508a.302.302 0 00-.11-.412.302.302 0 00-.412.11l-1.468 2.542A8.965 8.965 0 0012 8.545c-1.97 0-3.79.635-5.258 1.687L5.274 7.19a.302.302 0 00-.412-.11.302.302 0 00-.11.412L6.2 10c-2.133 1.454-3.548 3.795-3.548 6.453 0 .303.017.602.048.898h18.6c.031-.296.048-.595.048-.898C21.348 13.795 19.933 11.454 17.9 10z"/>
  </svg>
);

const AppleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
  </svg>
);

const GlobeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
  </svg>
);

const Home = () => (
  <div className="home-page">
    <SEO
      title="Appshow — Apps that supercharge your life"
      description="Discover innovative mobile apps for relationships, learning, emotional wellness, credit card rewards, and price tracking. Privacy-first apps for iOS and Android."
      keywords="mobile apps, privacy apps, relationship tracker, mood tracker, quiz app, credit card rewards, price tracker, iOS, Android"
      url="/"
    />

    {/* Hero */}
    <section className="home-hero">
      <div className="container">
        <h1 className="hero-title">Apps that supercharge<br />your life</h1>
        <p className="hero-subtitle">
          Discover apps built to solve real problems — crafted with attention
          to detail and your privacy in mind.
        </p>
        <a href="#products" className="btn-primary">View Products</a>
      </div>
    </section>

    {/* Products */}
    <section className="home-products" id="products">
      <div className="container">
        <div className="section-header">
          <h2>Products</h2>
          <p>Applications built to solve real problems. Each product is crafted with attention to detail and user experience.</p>
        </div>
        <div className="products-grid">
          {products.map(product => (
            <div className="product-card" key={product.to}>
              <div className="product-card-top">
                {product.image
                  ? <img src={product.image} alt={product.imageAlt} className="product-preview-img" loading="lazy" />
                  : <div className="product-placeholder-img" />
                }
                <span className="badge-live">Live</span>
              </div>
              <div className="product-card-body">
                <div className="product-category">{product.category}</div>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-tagline">{product.tagline}</p>
                <p className="product-desc">{product.description}</p>
                <div className="product-actions">
                  <Link to={product.to} className="btn-primary" style={{fontSize: '0.85rem', padding: '0.55rem 1.1rem'}}>
                    Learn More
                  </Link>
                  <div className="store-btns">
                    {product.android && (
                      <a href={product.android} target="_blank" rel="noopener noreferrer" className="btn-store" aria-label="Get on Google Play">
                        <AndroidIcon /> Android
                      </a>
                    )}
                    {product.ios && (
                      <a href={product.ios} target="_blank" rel="noopener noreferrer" className="btn-store" aria-label="Download on App Store">
                        <AppleIcon /> iOS
                      </a>
                    )}
                    {product.web && !product.android && !product.ios && (
                      <a href={product.web} target="_blank" rel="noopener noreferrer" className="btn-store" aria-label="Visit website">
                        <GlobeIcon /> Website
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default Home;
